<main class="container">
  <div class="m-4">
    <div class="card  ">
      <div class="row m-4">
        <!--                <prettyjson [obj]="selectedCentre"></prettyjson>-->
        <ng-container *ngIf="mId!=null">
          <div class="col-md-6 mt-2">
            {{ selectedCentre?.centreName }}
          </div>
        </ng-container>

        <mat-form-field appearance="outline" class="col-md-3 mt-2" *ngIf="mId==null">
          <mat-label>Select Centre</mat-label>
          <mat-select [(ngModel)]="selectedCentre" (selectionChange)="onCentreSelect($event)">
            <mat-option *ngFor=" let c of (centres$|async) "
                        [value]="c">{{ c.centreName }}
            </mat-option>
            <!--      <mat-option  value="All">All Centres</mat-option>-->
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-3 mt-2" *ngIf="mId==null">
          <mat-label>Report Type</mat-label>
          <mat-select [(ngModel)]="reportType" (selectionChange)="onReportTypeSelect($event)">
            <mat-option *ngFor=" let type of reportTypes" [value]="type">{{type}}</mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field appearance="outline" class="col-md-3 mt-2">
          <mat-label>Select a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date">
            <input matEndDate [(ngModel)]="mEndDate" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY to DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <button mat-mini-fab class="mt-2" (click)="searchData()">
          <mat-icon>search</mat-icon>
        </button>
        <div class="col-md-6 mt-2 ">
          <label for="bigTextArea" class="fw-bold"> Problem Addressed in Counselling:</label>

          <textarea id="bigTextArea" class="form-control" rows="5" cols="50"
                    [(ngModel)]="problemAddressed"></textarea>
        </div>
        <div class="col-md-6 mt-2">
          <label for="counselling" class="fw-bold">Counselling:</label>

          <textarea id="counselling" class="form-control" rows="5" cols="50"
                    [(ngModel)]="counselling"></textarea>
        </div>

        <div class="col-md-6 mt-2">
          <label for="intervention" class="fw-bold">Intervention & Tools used:</label>
          <textarea id="intervention" class="form-control" rows="5" cols="50" [(ngModel)]="intervention">
  </textarea>
        </div>


        <div class="col-md-6 mt-2">
          <label for="group" class="fw-bold">Group Counselling/ Activities:</label>
          <textarea id="group" class="form-control" rows="5" cols="50"
                    [(ngModel)]="groupCounselling"></textarea>
        </div>


        <mat-form-field appearance="outline" class="col-md-12 mt-2">
          <mat-label>Paragraph 1</mat-label>
          <textarea type="text" matInput [(ngModel)]="para1"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-12 mt-2">
          <mat-label>Paragraph 2</mat-label>
          <textarea type="text" matInput [(ngModel)]="para2"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-12 mt-2">
          <mat-label>End Line1</mat-label>
          <textarea type="text" matInput [(ngModel)]="endLine1"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-12 mt-2">
          <mat-label>End Line2</mat-label>
          <textarea type="text" matInput [(ngModel)]="endLine"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Individual Sessions</mat-label>
          <input type="number" matInput [(ngModel)]="individualSessionsControl">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Group Sessions</mat-label>
          <input type="number" matInput [(ngModel)]="groupSessionsControl">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Assessment Sessions</mat-label>
          <input type="number" matInput [(ngModel)]="totalAssesssmentSessionsControl">
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-end">
        <mat-form-field appearance="outline" class="mx-2 mt-2">
          <mat-label> Select Before Submit</mat-label>
          <mat-select [(ngModel)]="selectedSubmit">
            <mat-option value="draft">Draft</mat-option>
            <mat-option value="final">Final</mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button mat-raised-button color="accent" class="m-2"
                  (click)="openPhotoGallery()"
                  matTooltip="Select images from counselling session galleries">
            <mat-icon>photo_library</mat-icon> Photo Gallery
          </button>
          <button mat-raised-button  color="primary" class="m-2" (click)="save()">Submit</button>
          <button mat-raised-button color="primary" class="m-2" (click)="printDoc()">Download Report</button>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Photo Gallery Section ─── -->
  <div class="m-4">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-2">
          <mat-icon>photo_library</mat-icon>
          <h5 class="mb-0">Photo Gallery</h5>
          <span *ngIf="galleryImages.length > 0"
                style="background:#673ab7;color:white;padding:4px 12px;border-radius:12px;font-size:13px;">
            {{ galleryImages.length }} image(s)
          </span>
        </div>
        <div *ngIf="galleryImages.length > 0">
          <button mat-raised-button color="accent" (click)="openPhotoGallery()" class="mr-2">
            <mat-icon>add</mat-icon> Add More
          </button>
          <button mat-raised-button color="warn" (click)="clearGallery()">
            <mat-icon>clear_all</mat-icon> Clear All
          </button>
        </div>
      </div>
      <div class="card-body">

        <!-- Empty state -->
        <div *ngIf="galleryImages.length === 0" class="text-center py-4">
          <mat-icon style="font-size:48px;width:48px;height:48px;color:#999;">photo_library</mat-icon>
          <p class="text-muted mt-2">No images selected yet. Use the <strong>Photo Gallery</strong> button above to pick images from counselling session documents.</p>
          <button mat-raised-button color="accent" (click)="openPhotoGallery()">
            <mat-icon>add_photo_alternate</mat-icon> Select from Session Gallery
          </button>
        </div>

        <!-- Gallery Grid -->
        <div *ngIf="galleryImages.length > 0" class="gallery-grid">
          <div *ngFor="let img of galleryImages; let i = index" class="gallery-item">
            <div class="image-container">
              <img [src]="img.url"
                   [alt]="img.fileName"
                   (click)="openImageInNewTab(img.url)"
                   class="gallery-image">
              <div class="image-overlay">
                <button mat-mini-fab color="warn"
                        (click)="removeImageFromGallery(i)"
                        class="remove-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="image-info">
              <div class="image-filename" [title]="img.fileName">{{ img.fileName }}</div>
              <div class="image-meta" *ngIf="img.centreName">
                <mat-icon class="meta-icon">location_on</mat-icon>{{ img.centreName }}
              </div>
              <div class="image-meta" *ngIf="img.description">
                <mat-icon class="meta-icon">description</mat-icon>{{ img.description }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="bg-white p-2" #content id="previewCounselingReports">
    <section>
      <div style="display: flex; justify-content: flex-end;">
        <img style="height: 100px;" src="../../../../../assets/logo.png" alt="logo">
      </div>
    </section>

    <section class="text-dark">
      <div class="text-center">
        <h1 class="mb-0" style="text-align: center;"><strong>COUNSELLING IMPACT REPORT</strong></h1>
      </div>

      <div class="mx-8 mt-6">
        <p style="text-align: justify; text-justify: inter-word">{{ para1 }}</p>
        <p style="text-align: justify; text-justify: inter-word">{{ para2 }}</p>
      </div>

      <div class="mx-8 mt-6">
        <h3>Session Counts</h3>
        <ul>
          <li>Individual Sessions: {{ individualSessionsControl ?? getTotalSessions() }}</li>
          <li>Group Sessions: {{ groupSessionsControl ?? mAllGroupSessions.length }}</li>
          <li>Assessment Sessions: {{ totalAssesssmentSessionsControl ?? mAllAssessments.length }}</li>
          <li><b>Total Sessions: {{ getGrandTotalSessions() }}</b></li>
        </ul>
      </div>

      <div class="mx-8">
        <h4>Problem Addressed in Counselling:</h4>
        <p style="text-align: justify;text-justify: inter-word">{{ problemAddressed }}</p>
        <p style="text-align: justify;text-justify: inter-word">{{ counselling }}</p>

        <h4>Intervention & Tools used:</h4>
        <p style="text-align: justify;text-justify: inter-word">{{ intervention }}</p>

        <h4>Group Counselling/Activities:</h4>
        <p style="text-align: justify;text-justify: inter-word">{{ groupCounselling }}</p>

        <!-- Gallery images for print/PDF -->
        <div *ngIf="galleryImages.length > 0"
             style="display:flex;flex-wrap:wrap;gap:16px;margin-top:12px;max-width:720px;">
          <ng-container *ngFor="let img of galleryImages">
            <div style="flex:0 0 calc(20% - 12px);text-align:center;">
              <img [src]="img.url"
                   [alt]="img.fileName"
                   (click)="openImagePreview(img.url)"
                   style="width:130px;height:130px;object-fit:cover;border:1px solid #ccc;cursor:pointer;border-radius:4px;" />
              <div style="font-size:10px;color:#555;margin-top:4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                {{ img.centreName || img.fileName }}
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Image Preview Popup -->
        <div *ngIf="showPreview"
             style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;">
          <div style="position: relative;">
            <img [src]="previewImageUrl" alt="Preview" style="max-width: 90vw; max-height: 90vh; border: 4px solid #fff; border-radius: 8px;" />
            <button (click)="closeImagePreview()"
                    style="position: absolute; top: 8px; right: 8px; background: #fff; border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 20px; cursor: pointer;">&times;</button>
          </div>
        </div>



        <p class="mt-5" style="text-align: justify; text-justify: inter-word" *ngIf="showDischargeChart || showAdmissionChart">
          The Psychological Assessment data is analyzed to determine the level of coping ability and mental/emotional
          well-being.
          The following is the graphical representation of this data.
        </p>

        <div style="margin: 20px;" #pageBreak>
          <h2 style="font-weight: bold; text-align: center;">{{ childDetails?.childName }}</h2>

          <div style="margin: 10px;" *ngIf="showAdmissionChart">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <app-apex-piechart
                *ngIf="showAdmissionChart && apexChartData1.length >= 1 && doughnutChartLabels.length >= 1"
                [chartLabels]="doughnutChartLabels"
                [chartTitle]="'Admission/Baseline Psychological Assessment'"
                [chartData]="apexChartData1">
              </app-apex-piechart>
<!--              <div style="display: flex; justify-content: space-between; margin: 10px; gap:100px;">-->
<!--                <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="apexChartData1[1] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                  <img src="../../../../../assets/images/smiley/greenSmiley.png" alt="green smiley" style="width: 1rem;">-->
<!--                </div>-->

<!--                &lt;!&ndash; Show neutral smiley if No percentage is greater than 1% &ndash;&gt;-->
<!--                <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="apexChartData1[2] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                  <img src="../../../../../assets/images/smiley/neutral.png" alt="neutral smiley" style="width: 1rem;">-->
<!--                </div>-->

<!--                &lt;!&ndash; Show red emoji if Sometimes percentage is greater than 1% &ndash;&gt;-->
<!--                <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="apexChartData1[0] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                  <img src="../../../../../assets/images/smiley/redEmoji.png" alt="sad smiley" style="width: 1rem;">-->
<!--                </div>-->
<!--            </div>-->

          </div>
            </div>

            <div style="margin-top: 20px;" *ngIf="showDischargeChart">
              <div style="display: flex; flex-direction: column; align-items: center;">
                <app-apex-piechart
                  *ngIf="showDischargeChart && mDischargeChartData.length >= 1 && doughnutChartLabels.length >= 1"
                  [chartLabels]="doughnutChartLabels"
                  [chartTitle]="'Discharge/Final Baseline Assessments'"
                  [chartData]="mDischargeChartData">
                </app-apex-piechart>
<!--                <div style="display: flex; justify-content: space-between; margin: 10px; gap:100px;">-->
<!--                  &lt;!&ndash; Show green smiley if Yes percentage is greater than 1% &ndash;&gt;-->
<!--                  <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="mDischargeChartData[1] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                    <img src="../../../../../assets/images/smiley/greenSmiley.png" alt="green smiley" style="width: 1rem;">-->
<!--                  </div>-->

<!--                  &lt;!&ndash; Show neutral smiley if No percentage is greater than 1% &ndash;&gt;-->
<!--                  <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="mDischargeChartData[2] > 1" cdkßDragBoundary=".example-boundary" cdkDrag>-->
<!--                    <img src="../../../../../assets/images/smiley/neutral.png" alt="neutral smiley" style="width: 1rem;">-->
<!--                  </div>-->

<!--                  &lt;!&ndash; Show red emoji if Sometimes percentage is greater than 1% &ndash;&gt;-->
<!--                  <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="mDischargeChartData[0] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                    <img src="../../../../../assets/images/smiley/redEmoji.png" alt="sad smiley" style="width: 1rem;">-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>




            <p *ngIf="showAdmissionChart || showDischargeChart" style="text-align: justify;text-justify: inter-word">
            <strong>Frequency of low coping:</strong> The number of circumstances beneficiaries reported to be stressed
            and unable to cope.
            <br>
            <strong>Frequency of moderate coping:</strong> The number of circumstances beneficiaries reported stress and
            inability to cope half of the time.
            <br>
            <strong>Frequency of high coping:</strong> The number of circumstances beneficiaries reported no stress and
            the ability to cope.
            As can be seen from the first graph, the ability to cope was reported low when the families came to the
            center.
          </p>

          <p style="text-align: justify; text-justify: inter-word">{{ endLine1 }}</p>
          <p style="text-align: justify; text-justify: inter-word">{{ endLine }}</p>
        </div>
      </div>
    </section>
  </div>

</main>
